import { connect } from 'react-redux';
import IdMappingComponent from './id-mapping-component';
import execute from './grid/redux/action';

const mapStateToProps = (state: any) => ({
  application: state.application,
  queries: state.management.idMapping.form.queries
});
export default connect(mapStateToProps, { execute })(IdMappingComponent);
